import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import config from 'config'
import { orderBy } from 'lodash'
import { insertMessagesInItems } from 'lib/messagesLib'

import useSnackbar from '../Snackbar/useSnackbar'

const useCarsBooked = () => {
  const { t } = useTranslation()
  const { showSnackbarMessage } = useSnackbar()

  const [state, setState] = useState({
    isFetching: false,
    isUpdating: false,
    cars: [],
    total: 0,
    error: null,
  })

  const setStartFetching = useCallback(() => {
    setState((s) => ({
      ...s,
      isFetching: true,
      isUpdating: false,
    }))
  }, [setState])

  const setStopFetching = useCallback(
    (error) => {
      setState((s) => ({
        ...s,
        isFetching: false,
        error: error,
      }))
    },
    [setState]
  )

  // const setStartUpdating = useCallback(() => {
  //   setState((s) => ({
  //     ...s,
  //     isFetching: false,
  //     isUpdating: true,
  //   }))
  // }, [setState])

  // const setStopUpdating = useCallback(() => {
  //   setState((s) => ({
  //     ...s,
  //     isUpdating: false,
  //   }))
  // }, [setState])

  const setSuccessFetching = useCallback(
    (data) => {
      setState((s) => ({
        ...s,
        isFetching: false,
        isUpdating: false,
        ...data,
        error: null,
      }))
    },
    [setState]
  )

  const fetchCarsBooked = useCallback(
    async (sessionId, partnerId) => {
      setStartFetching()
      try {
        const results = await axios.get(
          `${config.apiBaseUrl}sessions/${sessionId}/partners/${partnerId}/cars-booked`
        )

        const cars = orderBy(results.data.body.items, ['title'], ['asc'])

        const messagesResult = await axios.get(
          `${config.apiBaseUrl}sessions/${sessionId}/messages`
        )

        const messages = messagesResult.data.body.messages.filter(
          (message) => message.partnerId === partnerId
        )

        insertMessagesInItems(messages, cars)

        setSuccessFetching({
          cars,
          total: results.data.body.total,
        })
      } catch (e) {
        const message =
          e.response?.data?.message ||
          t('common.error.fetchData', {
            attribute: e.response?.status,
          })

        setStopFetching(e)

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [
      setStartFetching,
      setStopFetching,
      setSuccessFetching,
      showSnackbarMessage,
      t,
    ]
  )

  return {
    cars: state.cars,
    total: state.total,
    isFetching: state.isFetching,
    isUpdating: state.isUpdating,
    error: state.error,
    fetchCarsBooked,
  }
}

export default useCarsBooked
